import { render } from "./HeaderLayout.vue?vue&type=template&id=3a80463e&scoped=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import "./HeaderLayout.vue?vue&type=style&index=0&id=3a80463e&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a80463e"]])

export default __exports__